import MultipartQuestion from "../../models/multipart-question";
import BaseComponent from "../base-component.js";
import { h } from "preact"

export default class MultipartQuestionComponent extends BaseComponent {
    responseCollector() {
        if (!(this.props.item instanceof MultipartQuestion)) return;
        let item = this.props.item;

        return <div class="multipart-container">
            {item.parts.map((part, index) => {
                let partId = (part.attributes.assessment_item_id != null ? Number(part.attributes.assessment_item_id): Number(part.id));
                return <div class="multipart-part" id={`part_${part.id}`} data-part-id={`${part.id}`}>
                    <div class="multipart-header">
                        {"Part " + String.fromCharCode(index+65)}
                    </div>
                    {h(part.component(this.props.mode), {
                        ...this.props, ...{
                            item: part,
                            didRender: () => {},
                            studentResponse: (this.props.studentResponse?.multipart?.parts.find((responsePart) => {
                                return responsePart && responsePart.question_part_id == partId
                            }) || null),
                            updateStudentResponse: (response) => {
                                let parts = this.props.studentResponse?.multipart?.parts || [];
                                parts[index] = { ...response, question_part_id: partId };
                                this.props.updateStudentResponse({ multipart: { parts: parts } });
                            }
                        }
                    })}
                </div>
            })}
        </div>
    }

    componentDidMount() {
        this.props.didRender();
    }

    render() {
        return this.wrapper(
            this.body(),
            this.responseCollector()
        )
    }
}
